// import { User } from './lib/User';
import { User2 } from './lib/User2';
export * from './lib/components';
export * from './lib/hooks';
export default User2;
